import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { LoadApprovalDialogComponent } from './load-approval-dialog.component';

@NgModule({
  declarations: [LoadApprovalDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  exports: [LoadApprovalDialogComponent],
})
export class LoadApprovalModule {}
